import { Box, Typography } from "@mui/material";
import colors from "../../Constants/colors";

export interface SectionDescriptionProps {
  description: string;
}

export function SectionDescription({ description }: SectionDescriptionProps) {
  return (
    <Box>
      <Typography
        variant="body2"
        sx={{
          color: colors.gray700,
          lineHeight: 1.7,
          fontSize: "0.95rem",
          whiteSpace: "pre-line",
        }}
      >
        {description}
      </Typography>
    </Box>
  );
}
